import * as React from "react"

const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    //width={345}
    //height={55}
    viewBox="110 0 100 62"
    {...props}
  >
    <text
      xmlSpace="preserve"
      x={360.361}
      y={487.376}
      style={{
        fontStyle: "normal",
        fontVariant: "normal",
        fontWeight: 400,
        fontStretch: "normal",
        fontSize: "73.3334px",
        lineHeight: 0,
        display: "inline",
        fontFamily: "&quot",
        InkscapeFontSpecification: "&quot",
        fill: "red",
        fillRule: "evenodd",
        stroke: "#ff5c00",
        strokeWidth: 1.75748,
        strokeDasharray: "none",
        strokeOpacity: 1,
      }}
      transform="translate(-363 -434.43)"
    >
      <tspan
        x={360.361}
        y={487.376}
        style={{
          fontStyle: "normal",
          fontVariant: "normal",
          fontWeight: 400,
          fontStretch: "normal",
          fontSize: "73.3334px",
          fontFamily: "&quot",
          InkscapeFontSpecification: "&quot",
          stroke: "#ff5c00",
          strokeWidth: 1.75748,
          strokeDasharray: "none",
          strokeOpacity: 1,
        }}
      >
        <tspan
          style={{
            fontSize: "73.3334px",
            display: "inline",
            fill: "#ff5c00",
            fillOpacity: 1,
            stroke: "#ff5c00",
            strokeWidth: 1.75748,
            strokeOpacity: 1,
          }}
        >
          {"GTOR"}
        </tspan>
        <tspan
          style={{
            fontSize: "73.3334px",
            fill: "none",
            stroke: "#ff5c00",
            strokeWidth: 1.75748,
            strokeDasharray: "none",
            strokeOpacity: 1,
          }}
        >
          {"RES"}
        </tspan>
      </tspan>
    </text>
  </svg>
)

export default SvgComponent
